module.exports = __webpack_public_path__ + "img/zip.254fb555.svg";